module.exports = __webpack_public_path__ + "img/flowPath-item4-off.d8c8b581.png";